import { trendingList } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';

const rankStyle = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-background-50';
  if (rank === 2) return 'bg-primary-500 text-background-50';
  if (rank === 3) return 'bg-foreground-800 text-background-50';
  return 'bg-background-200 text-foreground-700';
};

const trendIcon = (change: string) => {
  if (change === 'up') return { icon: 'ri-arrow-up-line', cls: 'text-accent-600' };
  if (change === 'down') return { icon: 'ri-arrow-down-line', cls: 'text-secondary-600' };
  return { icon: 'ri-subtract-line', cls: 'text-foreground-400' };
};

export default function TrendingList() {
  return (
    <section id="trending" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-primary-700">TODAY / 热榜</span>
              <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                今日热榜，一屏看完大家在吵什么
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                按讨论热度实时排序，点开任意一条都能看到完整的评论与观点。
              </p>
            </div>
            <button
              type="button"
              className="w-fit cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              完整榜单
            </button>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-7 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="hidden grid-cols-12 gap-4 border-b border-background-200 px-5 py-3 text-xs text-foreground-500 md:grid">
              <span className="col-span-1">排名</span>
              <span className="col-span-7">讨论话题</span>
              <span className="col-span-2">版块</span>
              <span className="col-span-2 text-right">热度</span>
            </div>
            {trendingList.map((item) => {
              const trend = trendIcon(item.change);
              return (
                <a
                  key={item.id}
                  href="#topics"
                  className="group grid cursor-pointer grid-cols-12 items-center gap-3 border-b border-background-100 px-4 py-3.5 transition-colors last:border-b-0 hover:bg-background-100 md:gap-4 md:px-5"
                >
                  <span className="col-span-2 md:col-span-1">
                    <span
                      className={`flex h-6 w-6 items-center justify-center rounded-md text-xs font-semibold ${rankStyle(
                        item.rank
                      )}`}
                    >
                      {item.rank}
                    </span>
                  </span>
                  <span className="col-span-10 md:col-span-7">
                    <span className="block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                      {item.title}
                    </span>
                  </span>
                  <span className="col-span-6 md:col-span-2">
                    <span className="inline-block rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                      {item.tag}
                    </span>
                  </span>
                  <span className="col-span-6 flex items-center justify-end gap-1.5 md:col-span-2">
                    <span className="text-sm font-medium text-foreground-900">{item.heat}</span>
                    <span className={`flex h-4 w-4 items-center justify-center ${trend.cls}`}>
                      <i className={`${trend.icon} text-sm`} />
                    </span>
                  </span>
                </a>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}